<template>
  <div class="mobile-app-offer">
    <div class="mobile-app-offer__container">
      <div class="text-md font-bold text-white leading-tight mr-auto">{{ offerText }}</div>
      <a v-if="mobileOS === 'iOS'"
         href="https://apps.apple.com/ru/app/id1542338653">
        <img :src="appStoreBtnLogo" alt="App Store icon">
      </a>
      <span v-else-if="mobileOS === 'Android'"
            class="store-badge store-badge--soon">
        <img :src="googlePlayBtnLogo" alt="Google Play — скоро">
        <span class="store-badge__soon">{{ $t('soon') }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import appStoreBtnLogo from '@/assets/icons/download-appstore.svg'
import googlePlayBtnLogo from '@/assets/icons/download-googleplay.svg'

export default {
  name: "MobileApplicationOffer",
  data() {
    return {
      appStoreBtnLogo,
      googlePlayBtnLogo,
    }
  },
  computed: {
    mobileOS() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
        return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      return null;
    },
    offerText() {
      return this.mobileOS === 'Android' ? this.$t('androidSoonText') : this.$t('goToAppText');
    }
  },
  i18n: {
    messages: {
      en: {
        goToAppText: 'Better experience in app!',
        androidSoonText: 'Android app coming soon',
        soon: 'Soon'
      },
      ru: {
        goToAppText: 'Удобнее в приложении!',
        androidSoonText: 'Android-приложение скоро',
        soon: 'Скоро'
      }
    }
  }
}
</script>

<style lang="scss">
.mobile-app-offer {
  @apply px-6 py-6 -mb-6;
  background: rgba(0, 0, 0, 0.4);

  img {
    width: 110px;
  }

  &__container {
    @apply flex items-center mx-auto;
    max-width: 300px;
  }
}

.store-badge {
  position: relative;
  display: inline-block;
  line-height: 0;
  cursor: default;

  img {
    display: block;
  }

  &__soon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 3px 8px;
    border-radius: 4px;
    background: #E04067;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    line-height: 1;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.28);
  }
}
</style>
